import { 
    FETCH_ALL_USERS,
    FETCH_ALL_USERS_SUCCESS,
    FETCH_ALL_USERS_FAILED,
    FETCH_ALL_USERS_STATIC,
    FETCH_ALL_USERS_STATIC_SUCCESS,
    FETCH_ALL_USERS_STATIC_FAILED,
    EDIT_USER,
    FETCH_ALL_DRIVERS,
    FETCH_ALL_DRIVERS_SUCCESS,
    FETCH_ALL_DRIVERS_FAILED
  } from "../store/types";
  
  export const INITIAL_STATE = {
    users:null,
    staticusers:null,
    drivers: null,
    loading: false,
    error:{
      flag:false,
      msg: null
    }
  }
  
  export const usersreducer =  (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_ALL_USERS:
        return {
          ...state,
        };
      case FETCH_ALL_USERS_SUCCESS:
        return {
          ...state,
          users:action.payload,
        };
      case FETCH_ALL_USERS_FAILED:
        return {
          ...state,
          users:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case FETCH_ALL_DRIVERS:
        return {
          ...state
        };
      case FETCH_ALL_DRIVERS_SUCCESS:
        return {
          ...state,
          drivers:action.payload
        };
      case FETCH_ALL_DRIVERS_FAILED:
        // No poner drivers:null: el mapa se queda vacío y “parece que no carga”.
        // Conservar la última lista y solo marcar el error.
        return {
          ...state,
          error:{
            flag:true,
            msg:action.payload
          }
        };  
      case FETCH_ALL_USERS_STATIC:
        return {
          ...state,
          loading:true
        };
      case FETCH_ALL_USERS_STATIC_SUCCESS:
        return {
          ...state,
          staticusers:action.payload,
          loading:false
        };
      case FETCH_ALL_USERS_STATIC_FAILED:
        return {
          ...state,
          staticusers:null,
          loading:false,
          error:{
            flag:true,
            msg:action.payload
          }
        };
      case EDIT_USER: {
        const edited = action.payload;
        const uid = edited && (edited.id || edited.uid);
        if (!uid || !Array.isArray(state.staticusers)) {
          return state;
        }
        // Actualización optimista: el switch de "Cuenta aprobada" (y otros campos) se refleja al instante
        let found = false;
        const staticusers = state.staticusers.map((u) => {
          if (u.id !== uid) return u;
          found = true;
          return { ...u, ...edited, id: uid };
        });
        return found ? { ...state, staticusers } : state;
      }
      default:
        return state;
    }
  };